/** What kind of stored record a resolve request points at. The route never
 *  accepts free text — see spec D.1. Additive by design. */
export enum GeoContentRefKind {
  ProductVersion = 'productVersion',
  Collab = 'collab',
}

/** Outcome of a single geocode attempt. Drives cache retention: `Resolved` is
 *  long-lived, `NotFound`/`Ambiguous` are bounded, `Failed` must never be
 *  permanent — a transient upstream outage must not poison a query forever. */
export enum GeoResolveStatus {
  Resolved = 'resolved',
  Ambiguous = 'ambiguous',
  NotFound = 'notFound',
  Failed = 'failed',
}

/** Which backend produced a projection. Pelias is standby-only in the
 *  research suite (no free hosted instance exists) and is not wired here. */
export enum GeoVendor {
  Nominatim = 'nominatim',
  Photon = 'photon',
}

/** OSM object class. Nominatim spells these `node`/`way`/`relation`; Photon
 *  spells them `N`/`W`/`R` — the adapters normalize into this enum. This is
 *  the durable join key: Nominatim's `place_id` is instance-local and must
 *  never be persisted in its place. */
export enum OsmType {
  Node = 'node',
  Way = 'way',
  Relation = 'relation',
  Unknown = 'unknown',
}

/** Unified across vendors. Drives framing and the default radius. See
 *  `planning/research-layer/modules/geo-local/geocoding--suite.md` section 5
 *  for the `place_rank` / Photon `type` derivation table. */
export enum LocationGranularity {
  Country = 'country',
  Region = 'region',
  County = 'county',
  City = 'city',
  District = 'district',
  Neighbourhood = 'neighbourhood',
  Street = 'street',
  Address = 'address',
  Poi = 'poi',
  Unknown = 'unknown',
}

/** Synthesized confidence — neither vendor supplies one natively. Nominatim's
 *  `importance` is a prominence score, not a match score, and Photon has no
 *  score field at all. */
export enum GeocodeConfidence {
  High = 'high',
  Medium = 'medium',
  Low = 'low',
  Ambiguous = 'ambiguous',
}
